import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        success: '#388E3C',
        error: '#C62828',
        primary: '#263238',
        info: '#FF5722'
      }
    },
    options: {
      customProperties: true
    }
  }
})
